// @flow

import type {Dispatch} from 'redux';
import {GET} from '../helpers/request';

export const GET_REQUEST = '@userList/GET_REQUEST';
export const GET_SUCCESS = '@userList/GET_SUCCESS';
export const GET_FAILURE = '@userList/GET_FAILURE';

export const FILTER = '@userList/FILTER';
export const SORT = '@userList/SORT';

type UserListGetRequestAction = {
  type: '@userList/GET_REQUEST'
};

type UserListGetSuccessAction = {
  type: '@userList/GET_SUCCESS',
  users: any[]
};

type UserListGetFailureAction = {
  type: '@userList/GET_FAILURE',
  error: any
};

type UserListFilterAction = {
  type: '@userList/FILTER',
  archived: bool,
  project: ?number,
  query: ?string,
};

type UserListSortAction = {
  type: '@userList/SORT',
  sorter: Function,
};

export type UserListAction
  = UserListGetRequestAction
  | UserListGetSuccessAction
  | UserListGetFailureAction
  | UserListFilterAction
  | UserListSortAction;

const usersRequest = (): UserListGetRequestAction => ({
  type: GET_REQUEST,
});

const usersSuccess = (users: any[]): UserListGetSuccessAction => ({
  type: GET_SUCCESS,
  users,
});

const usersFailure = (error: any): UserListGetFailureAction => ({
  type: GET_FAILURE,
  error,
});

export const fetchUsers = () => async (dispatch: Dispatch<UserListAction>) => {
  dispatch(usersRequest());
  try {
    const users = await GET({endpoint: '/users'}, dispatch);
    dispatch(usersSuccess(users));
  } catch (err) {
    dispatch(usersFailure(err));
  }
};

export const filterUsers = (query: ?string, project: ?number, archived: bool): UserListFilterAction => ({
  type: FILTER,
  archived,
  project,
  query,
});

export const sortItems = (sorter: Function): UserListSortAction => ({
  type: SORT,
  sorter,
});



// WEBPACK FOOTER //
// ./src/actions/userList.js